import { S } from '../regureStyles';

const NewReportModal = ({ setNewReport, newReport, setShowNewForm, handleCreate, submitting }) => {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 32, width: 500, boxShadow: '0 25px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: S.textPrimary, marginBottom: 20 }}>New Compliance Report</div>
        {[
          { label: 'Report Name *', key: 'name', type: 'input', placeholder: 'e.g. FINMA Quarterly Report Q2 2026' },
          { label: 'Period', key: 'period', type: 'input', placeholder: 'e.g. Q2 2026' },
          { label: 'Due Date', key: 'dueDate', type: 'date', placeholder: '' },
        ].map(f => (
          <div key={f.key} style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, fontWeight: 500, color: S.textSecondary, display: 'block', marginBottom: 5 }}>{f.label}</label>
            <input
              type={f.type === 'date' ? 'date' : 'text'}
              value={newReport[f.key]}
              onChange={e => setNewReport(prev => ({ ...prev, [f.key]: e.target.value }))}
              placeholder={f.placeholder}
              style={{
                width: '100%',
                padding: '9px 12px',
                border: `1px solid ${S.borderLight}`,
                borderRadius: 8,
                fontSize: 13,
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>
        ))}
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 13, fontWeight: 500, color: S.textSecondary, display: 'block', marginBottom: 5 }}>Category *</label>
          <select
            value={newReport.category}
            onChange={e => setNewReport(prev => ({ ...prev, category: e.target.value }))}
            style={{ width: '100%', padding: '9px 12px', border: `1px solid ${S.borderLight}`, borderRadius: 8, fontSize: 13, outline: 'none', cursor: 'pointer' }}
          >
            {['Regulatory', 'Solvency', 'AML', 'GDPR', 'FADP', 'Other'].map(c => (
              <option key={c}>{c}</option>
            ))}
          </select>
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, fontWeight: 500, color: S.textSecondary, display: 'block', marginBottom: 5 }}>Notes</label>
          <textarea
            value={newReport.notes}
            onChange={e => setNewReport(prev => ({ ...prev, notes: e.target.value }))}
            rows={3}
            placeholder='Optional notes or description...'
            style={{
              width: '100%',
              padding: '9px 12px',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 13,
              outline: 'none',
              boxSizing: 'border-box',
              resize: 'vertical',
            }}
          />
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button
            onClick={() => setShowNewForm(false)}
            style={{
              padding: '10px 20px',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              background: S.bgCard,
              fontSize: 13,
              cursor: 'pointer',
              color: S.textSecondary,
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleCreate}
            disabled={!newReport.name.trim() || submitting}
            style={{
              padding: '10px 20px',
              background: !newReport.name.trim() ? '#94a3b8' : `linear-gradient(135deg, ${S.burgundy}, #722f37)`,
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: !newReport.name.trim() ? 'not-allowed' : 'pointer',
            }}
          >
            {submitting ? 'Creating...' : 'Create Report'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewReportModal;
